import { validateToken } from "./ValidateToken";

export const HandleResponse = async (response, navigate) => {
    if(response.ok){
        return
    }
    const valid = await validateToken();
    if(!valid){
        navigate('/login');
    }
};

